import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/forum/topic.svg'
import _imports_2 from '@/assets/img/management/add.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "d-flex flex-wrap mb-3 filterCont" }
const _hoisted_6 = { class: "fs_12 d-block" }
const _hoisted_7 = { class: "notificationsCount" }
const _hoisted_8 = { class: "fs_12 d-block" }
const _hoisted_9 = { class: "notificationsCount" }
const _hoisted_10 = { class: "fs_12 d-block" }
const _hoisted_11 = { class: "notificationsCount" }
const _hoisted_12 = { class: "adminButtonContainer" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_gestisciAllegati",
        text: "Gestisci allegati"
      }),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: ["filterTab d-flex", _ctx.categorySelectedId == 'all'  ? 'active' : ''],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.categorySelectedId = 'all'))
      }, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_localized_text, {
            class: "",
            localizedKey: "app_tuttiallegati",
            text: "Tutti"
          })
        ]),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.countCategory('all')), 1)
      ], 2),
      _createVNode("div", {
        class: ["filterTab", _ctx.categorySelectedId == 'noCat'  ? 'active' : ''],
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.categorySelectedId = 'noCat'))
      }, [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_localized_text, {
            class: "",
            localizedKey: "app_nocategoria",
            text: "Nessuna categoria"
          })
        ]),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.countCategory('noCat')), 1)
      ], 2),
      (_ctx.allCategories.length > 0)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.allCategories, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: ["filterTab", _ctx.categorySelectedId == item.id  ? 'active' : ''],
              key: item.id,
              onClick: ($event: any) => (_ctx.categorySelectedId = item.id)
            }, [
              _createVNode("span", _hoisted_10, _toDisplayString(item.name), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.countCategory(item.id)), 1)
            ], 10, ["onClick"]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    (_ctx.posts.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_nessunAllegatoPresente",
          text: "Nessun allegato presente",
          class: "fs_14 greyBlue d-block ln_12 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filtredPost, (item, i) => {
      return (_openBlock(), _createBlock(_component_post, {
        class: "mb-3",
        key: item.identifier,
        "is-block": true,
        post: item,
        "community-identifier": _ctx.$store.state.community.identifier,
        onPostreloaded: _ctx.init,
        "can-content": _ctx.$store.state.community.canContent,
        showActions: false
      }, null, 8, ["post", "community-identifier", "onPostreloaded", "can-content"]))
    }), 128)),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", {
        class: "managementButton",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.allegatiCategories()))
      }, [
        _hoisted_13
      ]),
      _createVNode("div", {
        class: "managementButton",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.newAttachment()))
      }, [
        _hoisted_14
      ])
    ])
  ]))
}